/**
 * Created by rhinov4 on 16/09/2015.
 */
import { CocosConstants } from "../../constants";
import { ScaleIndicator } from "./plan/Nodes/ScaleIndicator";
import { IdleConstruction } from "./state";
import { GameObjectManager } from "./plan/GameObjectManager";
import { PlanManager } from "../../cocosPlan";
import { Utils } from "./utils/Utils";
import { ComponentConstants, EntityFactory, Events, eventsManager, Floor, Functionality, JSONImporter, Listener, SceneConstants, Staircase, Wall, wallManager, World } from "@rhinov/savane-js";

declare var cc: any;
declare var $: any;
declare var bootbox: any;


export class MainSceneCocos extends cc.Scene {

    static PlanState = {
        not_ordered: 1,
        in_progress: 2,
        waiting_payment: 3,
        invalid: 4,
        done: 5,
        archived: 6,
        check_delivery: 7,
        waiting_validation: 8
    };

    newMenu: boolean = true;
    _width = 0;
    _height: number = 0;
    time: number = 0;
    deliverableID: number = -1;
    projectState: number = 0;
    _listener1: Listener | null = null;
    rhinovWorldData: any = null;
    planlayer: any = null;
    floorList: Array<Floor> | null = null;
    loaded: boolean = false;
    userRole: number = 0;
    prevToolType: string = '';
    quotationFormat: any = null;
    orderFormat: any = null;
    

    constructor(width: number, height: number) {
        super();
        this._width = width;
        this._height = height;
    }

    setRhinovFormat(rhinov: any, deliverableID: number) {
        this.rhinovWorldData = rhinov;
        this.deliverableID = deliverableID;
    }

    prepareForQuotation(orderFormat: any, quotationFormat: any) {
        this.quotationFormat = quotationFormat;
        this.orderFormat = orderFormat;
    }

    clearScene() {
        Utils.deleteLocal(CocosConstants.autosaveCookieName);
    }

    
    onStop() {
        this.removeAllChildren();
        PlanManager.deleteInstance();
        $(window).off('resize');
        eventsManager.instance.removeListener(this.clearLocalListener);
        eventsManager.instance.removeListener(this.loadLocalListener);
        eventsManager.instance.removeListener(this.scrollListener);
        eventsManager.instance.removeAllListeners(Events.PLAN_STATE_CHANGED);
        for (var i in Events) {
            if (Events.hasOwnProperty(i)) {
                cc.eventManager.removeCustomListeners((Events as any)[i]);
            }
        }
    }
    onEnterTransitionDidFinish() {
        var i, j;
        super.onEnterTransitionDidFinish();
        //Attach event listener to load local
        // this.loadLocalListener = eventsManager.instance.addListener(Events.LOAD_LOCAL_CACHE, function() {
        //     this.rhinovWorldData = autosaveTest.rhinov_format;
        //     PlanManager.getInstance().deliverableID = this.deliverableID;
        //     if (this.rhinovWorldData !== null) {
        //         this.loadSceneDatas();
        //     }
        //     PlanManager.getInstance().loadWorld(PlanManager.getInstance().world);
        //     PlanManager.getInstance().setActionCount(1);
        // });
        // this.clearLocalListener = eventsManager.instance.addListener(Events.CLEAR_LOCAL_CACHE, function() {
        //     Utils.deleteLocal(CocosConstants.autosaveCookieName);
        //     PlanManager.getInstance().deliverableID = this.deliverableID;
        //     if (this.rhinovWorldData !== null) {
        //         this.loadSceneDatas();
        //     }
        //     PlanManager.getInstance().loadWorld(PlanManager.getInstance().world);
        // });
        //Load project
        this.loadProject();

        PlanManager.getInstance().scrollWindow.centerPosition(false, false);

        if (this.quotationFormat !== null) {
            JSONImporter.importQuotation(JSON.parse(this.quotationFormat), PlanManager.getInstance().world);
        }
        if (this.orderFormat !== null) {
            var order = JSON.parse(this.orderFormat);
            if (order.rooms !== undefined) {
                for (i = 0; i < order.rooms.length; i++) {
                    var room = null;
                    var floors = PlanManager.getInstance().world.currentScene!.floors;
                    for (j = 0; j < floors.length; ++j) {
                        room = floors[j].getRoom(order.rooms[i].id);
                        if (room !== null) {
                            room.isOrdered = true;
                            break;
                        }
                    }
                }
            }
        }
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (i = 0; i < rooms.length; ++i) {
            GameObjectManager.drawRoom(rooms[i], false);
        }
        //PlanManager.getInstance().switchToEdition();
        eventsManager.instance.dispatch(Events.PROJECT_DID_LOAD);
    }

    //Update the scale indicator position to be set in the right bottom corner
    positionScaleIndicator() {
        // Position where to put the scale indicator
        var posX = this._width - (this.scaleIndicator.getFullLength() + 20);
        var posY = 50;
        this.scaleIndicator.setPosition(posX, posY);
    }

    onEnter() {
        super.onEnter();

        // Attempt to solve a crash at the start of the engine that says the frontViewLayer was added twice
        this.removeAllChildren();

        //savaneLocalize('test');
        cc.spriteFrameCache.addSpriteFrames(CocosConstants.resourcesBasePath + '/resources/HPSpriteSheet.plist');
        this.planlayer = PlanManager.getInstance().scrollWindow;
        this.planlayer.rebuildGrid();
        this.planlayer.setName('testPerso');
        this.scaleIndicator = new ScaleIndicator();
        this.positionScaleIndicator();

        this.addChild(PlanManager.getInstance().frontViewLayer, 3);
        this.addChild(this.planlayer, 1);
        this.addChild(this.scaleIndicator, 2);

        var callback = ((event: any) => {
            this.positionScaleIndicator();
            if (PlanManager.getInstance().frontViewLayer.isVisible()) {
                PlanManager.getInstance().frontViewLayer.resize(this._width, this._height);
            }

        });
        this.scrollListener = eventsManager.instance.addListener(Events.ZOOM_SCROLLWIN_CHANGED, callback.bind(this));

        $(window).on('resize', callback.bind(this));
    }
    unselectTool() {
        PlanManager.getInstance()._state.dispose();
        PlanManager.getInstance()._state = new IdleConstruction() as any;
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, PlanManager.getInstance().getAction());
        this.prevToolType = '';
    }
    // External Events
    undo() {
        eventsManager.instance.dispatch(Events.UNDO_EVENT);
    }
    redo() {
        eventsManager.instance.dispatch(Events.REDO_EVENT);
    }
    zoomIN() {
        eventsManager.instance.dispatch(Events.ZOOM_IN_EVENT);
    }
    zoomOUT() {
        eventsManager.instance.dispatch(Events.ZOOM_OUT_EVENT);
    }
    DispCote(checked: boolean) {
        eventsManager.instance.dispatch(Events.HIDE_DIMENSION_PRESSED, checked);
    }
    DispGrill(checked: boolean) {
        eventsManager.instance.dispatch(Events.HIDE_GRID_PRESSED, checked);
    }
    DispArea(checked: boolean) {
        PlanManager.getInstance().mustShowRoomArea = checked;
        eventsManager.instance.dispatch(Events.TOGGLE_ROOM_AREA, checked);
    }
    DispCamera(checked: boolean) {
        PlanManager.getInstance().mustShowCamera = checked;
        eventsManager.instance.dispatch(Events.TOGGLE_USER_PICTURES, checked);
    }
    DispRoomName(checked: boolean) {
        PlanManager.getInstance().mustShowRoomName = checked;
        eventsManager.instance.dispatch(Events.TOGGLE_ROOM_NAME, checked);
    }
    DispBackgroundImage(checked: boolean) {
        eventsManager.instance.dispatch(Events.HIDE_BACKGROUND_PRESSED, checked);
    }
    DispRulers(checked: boolean) {
        PlanManager.getInstance().setRulersActive(checked);
        eventsManager.instance.dispatch(Events.HIDE_RULERS_PRESSED, checked);
    }

    // Floor management ------------------------------------------------------------------------------------------------
    getFloorList(): Array<Floor> {
        return PlanManager.getInstance().getAllFloor();
    }
    setFloor(id: number) {
        PlanManager.getInstance().setCurrentFloorByIndex(id);
    }
    isLoaded(): boolean {
        return this.loaded;
    }
    /**
     * Method to add new floor
     * @param isUp
     * @returns {{}}
     */
    addFloor(floorConfig: any) {
        var beforeFloor = PlanManager.getInstance().getAllFloor().length;
        PlanManager.getInstance().CreateNewFloor(floorConfig);

        var sortByHeight = function(a: any, b: any) {
            if (a.height > b.height)
                return -1;
            else if (a.height < b.height)
                return 1;
            else
                return 0;
        };

        var floorList = PlanManager.getInstance().getAllFloor();
        var newFloorId = floorList[floorList.length - 1].id;
        PlanManager.getInstance().setCurrentFloorByIndex(newFloorId);
        floorList.sort(sortByHeight);
        if (floorConfig.walls || floorConfig.joineries || floorConfig.alltherest || floorConfig.papersketch) {
            var floorToClone = floorConfig.isUp ? floorList[1] : floorList[floorList.length - 2];

            if (floorConfig.walls || floorConfig.joineries) {
                for (var i = 0; i < floorToClone.compoundWalls.length; ++i) {
                    var toAdd = EntityFactory.getInstance().cloneWall(floorToClone.compoundWalls[i], true);
                    toAdd.deleteJoineries();
                    PlanManager.getInstance().addWall(toAdd, true);
                    if (floorConfig.joineries) {
                        var joineriesToClone = floorToClone.compoundWalls[i].joineries;
                        for (var j = 0; j < joineriesToClone.length; ++j) {
                            var joinery = EntityFactory.getInstance().cloneJoinery(joineriesToClone[j], true);
                            joinery.wall = toAdd;
                            PlanManager.getInstance().addJoinery(joinery);
                        }
                    }
                }

                for (var i = 0; i < floorToClone.technicalElementsWithStaircases.length; ++i) {
                    if (floorToClone.technicalElementsWithStaircases[i].isTechnicalElementEntity() && floorToClone.technicalElementsWithStaircases[i].objectId === SceneConstants.TechnicalElementType.pole) {
                        var techElementToClone = EntityFactory.getInstance().cloneTechnicalElement(floorToClone.technicalElementsWithStaircases[i], true);
                        PlanManager.getInstance().addTechnicalElement(techElementToClone);
                    }
                }
            }

            if (floorConfig.alltherest) {
                for (var i = 0; i < floorToClone.walls.length; ++i) {
                    if (floorToClone.compoundWalls.indexOf(floorToClone.walls[i]) === -1) {
                        var toAdd = EntityFactory.getInstance().createWall(floorToClone.walls[i].begin, floorToClone.walls[i].end);
                        toAdd.thickness = floorToClone.walls[i].thickness;
                        PlanManager.getInstance().addWall(toAdd, true);
                        if (floorConfig.joineries) {
                            var joineriesToClone = floorToClone.walls[i].joineries;
                            for (var j = 0; j < joineriesToClone.length; ++j) {
                                var joinery = EntityFactory.getInstance().cloneJoinery(joineriesToClone[j], true);
                                joinery.wall = toAdd;
                                PlanManager.getInstance().addJoinery(joinery);
                            }
                        }
                    }
                }

                for (var i = 0; i < floorToClone.technicalElementsWithStaircases.length; ++i) {
                    if (floorToClone.technicalElementsWithStaircases[i].isStaircaseEntity()) {
                        PlanManager.getInstance().addTechnicalElement(EntityFactory.getInstance().cloneStaircase(floorToClone.technicalElementsWithStaircases[i] as Staircase, true));
                    }
                    else {
                        if (floorToClone.technicalElementsWithStaircases[i].objectId !== SceneConstants.TechnicalElementType.pole) {
                            PlanManager.getInstance().addTechnicalElement(EntityFactory.getInstance().cloneTechnicalElement(floorToClone.technicalElementsWithStaircases[i], true));
                        }
                    }
                }

                for (var i = 0; i < floorToClone.geometryPrimitives.length; ++i) {
                    PlanManager.getInstance().addGeometryPrimitive(EntityFactory.getInstance().cloneGeometryPrimitive(floorToClone.geometryPrimitives[i], true));
                }
            }
            else {
                //Try to merge walls
                var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
                for (var i = 0; i < rooms.length; i++) {
                    var wallsR = rooms[i].walls;
                    for (var j = 0; j < wallsR.length; j++) {
                        var wallA = wallsR[j];
                        var wallB = j < wallsR.length - 1 ? wallsR[j + 1] : wallsR[0];
                        if (Wall.mergeWall(wallA, wallB) !== null) {
                            var newWall = wallManager.mergeWall(wallA, wallB);
                            PlanManager.getInstance().mergeWalls(newWall, [wallA, wallB]);
                            if (j < wallsR.length - 1) {
                                //Replace wall by new one in currently watched walls
                                wallsR[j + 1] = newWall;
                            }
                        }

                    }
                }
            }

            if (floorConfig.papersketch) {
                 var plan = floorToClone.getComponent(ComponentConstants.ComponentType.TemplateImage);

                 if (plan) {
                      PlanManager.getInstance().world.currentScene!.currentFloor!.addComponent(plan.clone());
                 }
            }

            PlanManager.getInstance().world.currentScene!.currentFloor!.readjustFloorsHeight();

            PlanManager.getInstance().saveInCache();

            PlanManager.getInstance().setCurrentFloorByIndex(newFloorId);
        }

        return {
            success: (beforeFloor !== PlanManager.getInstance().getAllFloor().length),
            floorList: PlanManager.getInstance().getAllFloor()
        };
    }
    deleteFloor(id: number) {
        var planManager = PlanManager.getInstance();
        var currentFloorId = planManager.world.currentScene!.currentFloor!.id;

        if (currentFloorId != id) {
            planManager.setCurrentFloorByIndex(id, true);
            currentFloorId = planManager.world.currentScene!.currentFloor!.id;
        }
        planManager.unloadCurrentFloor();
        planManager.unloadUnderFloor();
        planManager.removeCurrentFloor();
        if (currentFloorId != id) {
            planManager.setCurrentFloorByIndex(currentFloorId, true);
        }
        else {
            planManager.setCurrentFloorByIndex(planManager.world.currentScene!.floors[0].id);
        }
    }
    // END Floor management --------------------------------------------------------------------------------------------
    getProject(): World {
        //return this.project;
        return PlanManager.getInstance().world;
    }

    /**
     * Method to load project
     */
    loadProject() {
        //FIXME DISABLED COOKIE
        if (Utils.getLocal(CocosConstants.autosaveCookieName) !== null && PlanManager.getInstance().autoCache) {
            //console.log(Utils.getLocal(RequestConstants.AUTOSAVE_COOKIE_NAME));
            var autosaveTest = JSON.parse(Utils.getLocal(CocosConstants.autosaveCookieName));
            if (autosaveTest.deliverableID !== undefined) {
                if (autosaveTest.deliverableID === this.deliverableID) {
                    this.hasChoose = false;
                    if (typeof bootbox !== 'undefined') {
                        var warningUrl = CocosConstants.resourcesBasePath + '/resources/warning.png';
                        bootbox.dialog({
                            className: 'confirm',
                            message: "<img src='" + warningUrl + "'/><br>" + "Votre projet s'est fermé de manière imprévue, souhaitez vous rouvrir votre projet en cours ?",
                            buttons: {
                                success: {
                                    label: 'Annuler',
                                    className: 'btn btn-link',
                                    callback: (() => {
                                        this.hasChoose = true;
                                        Utils.deleteLocal(CocosConstants.autosaveCookieName);
                                        PlanManager.getInstance().deliverableID = this.deliverableID;
                                        if (this.rhinovWorldData !== null) {
                                            this.loadSceneDatas();
                                        }
                                        PlanManager.getInstance().loadWorld(PlanManager.getInstance().world);
                                    })
                                },
                                danger: {
                                    label: 'Confirmer',
                                    className: 'btn btn-link btn-yes',
                                    callback: (() => {
                                        this.hasChoose = true;
                                        this.rhinovWorldData = autosaveTest.rhinov_format;
                                        PlanManager.getInstance().deliverableID = this.deliverableID;
                                        if (this.rhinovWorldData !== null) {
                                            this.loadSceneDatas();
                                        }
                                        PlanManager.getInstance().loadWorld(PlanManager.getInstance().world);
                                        PlanManager.getInstance().setActionCount(1);
                                    })
                                }
                            }
                        }).on('hide.bs.modal', (() => {
                            if (this.hasChoose) {
                                return;
                            }
                            Utils.deleteLocal(CocosConstants.autosaveCookieName);
                            PlanManager.getInstance().deliverableID = this.deliverableID;
                            if (this.rhinovWorldData !== null) {
                                this.loadSceneDatas();
                            }
                            PlanManager.getInstance().loadWorld(PlanManager.getInstance().world);
                        }));
                        return;
                    } else {
                        //TODO Dispatch something to replace the bootbox
                        eventsManager.instance.dispatch(Events.LOCAL_CACHE_POPUP_DISPLAY)
                    }
                }
            }
        }
        //try {
        PlanManager.getInstance().deliverableID = this.deliverableID;
        if (this.rhinovWorldData !== null) {
            this.loadSceneDatas();
        }
        PlanManager.getInstance().loadWorld(PlanManager.getInstance().world);
    }
    checkInvalidFunc(idFunc: number): boolean {
        var list = GameObjectManager.roomFunctionalitiesData;
        for (var prop in list) {
            if ((list as any)[prop].id === idFunc) {
                return true;
            }
        }
        return false;
    }
    loadSceneDatas() {
        try {
            PlanManager.getInstance().world = JSONImporter.importWorld(this.rhinovWorldData);
            PlanManager.getInstance().world.currentScene!.currentFloor = PlanManager.getInstance().world.currentScene!.floors[0];
            var floors = PlanManager.getInstance().world.currentScene!.floors;
            for (var i = 0; i < floors.length; i++) {
                var rooms = floors[i].rooms;
                for (var j = 0; j < rooms.length; j++) {
                    var room = rooms[j];
                    var comp = room.getComponent(ComponentConstants.ComponentType.Functionality) as Functionality;
                    if (comp.functionalityId !== null) {
                        if (this.checkInvalidFunc(comp.functionalityId)) {
                            var secFuncs = room.secondaryFunctionalities;
                            for (var k = 0; k < secFuncs.length; k++) {
                                if (!this.checkInvalidFunc(secFuncs[k].functionalityId!)) {
                                    room.removeFunctionality(secFuncs[k].functionalityId!);
                                }
                            }
                        } else {
                            (comp as any).functionalityId = null;
                            (comp as any).functionalityName = null;
                            room.removeFunctionalities();
                        }
                    }
                }
            }
        } catch (exception) { }
    }
    //region addArrangementButton,exportToJSON,importImg,deployFloorList,clickOnFloorList,onPinch,onSwipe,setResolution,addUserPlan
    // addArrangementButton(parent, objectid, position) {
    //     var button = new ArrangementButton(objectid, parent.width * 0.45);
    //     button.setPosition(position);
    //     button.setAnchorPoint(0, 1);
    //     button.addCustomTouchListener();
    //     parent.addChild(button);
    // }
    onPinch(scale: number) {
        var scrollwindow = this.getChildByName('ScrollWindow');
        //console.log("Pinch : " + scale);
        scrollwindow.toZoom(scale);

        var frontViewLayer = this.getChildByName('frontViewLayer');
        if (frontViewLayer !== null) {
            frontViewLayer.toZoom(scale);
        }
    }
    onSwipe(deltaX: number) {
        console.log('MainScene.onSwipe:', deltaX);
    }
    setResolution(width: any, height: any) {
        this._width = width;
        this._height = height;
        this._contentSize.width = width;
        this._contentSize.height = height;

        var scrollWindow = this.getChildByName('ScrollWindow');
        if (scrollWindow) {
            scrollWindow.resize(width, height);
        }

        var backgroundColor = this.getChildByName('backgroundColor');
        if (backgroundColor) {
            backgroundColor.changeWidthAndHeight(width, height);
        }


        var frontViewLayer = this.getChildByName('frontViewLayer');
        if (frontViewLayer !== null) {
            frontViewLayer.resize(width, height);
        }
    }
    addUserPlan(texture: any, scale: number, userScale: number, rotate: number) {
        GameObjectManager.createUserMap(texture, scale, userScale, rotate);
    }

}



